import { createContext, useState, useEffect, useCallback } from "react";
import {
    shopifyCustomerLogin,
    shopifyCustomerLogout,
    shopifyCustomerCreate,
    shopifyGetCustomer,
    shopifyCustomerUpdate,
    shopifyCustomerAddressUpdate,
    shopifyCustomerAddressCreate,
} from '../lib/shopify';

export const UserContext = createContext();

const TOKEN_KEY = 'shopify_customer_token';

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);

    const fetchUser = useCallback(async () => {
        const token = localStorage.getItem(TOKEN_KEY);
        if (!token) return;
        try {
            const customer = await shopifyGetCustomer(token);
            if (customer) {
                setUser(customer);
            } else {
                localStorage.removeItem(TOKEN_KEY);
                setUser(null);
            }
        } catch {
            localStorage.removeItem(TOKEN_KEY);
            setUser(null);
        }
    }, []);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    const login = async (email, password) => {
        const token = await shopifyCustomerLogin(email, password);
        localStorage.setItem(TOKEN_KEY, token);
        const customer = await shopifyGetCustomer(token);
        setUser(customer);
    };

    const logout = async () => {
        const token = localStorage.getItem(TOKEN_KEY);
        if (token) {
            try { await shopifyCustomerLogout(token); } catch {}
        }
        localStorage.removeItem(TOKEN_KEY);
        setUser(null);
    };

    const register = async (firstName, lastName, email, password) => {
        await shopifyCustomerCreate(firstName, lastName, email, password);
        await login(email, password);
    };

    const updateCustomer = async (fields) => {
        const token = localStorage.getItem(TOKEN_KEY);
        await shopifyCustomerUpdate(token, fields);
        await fetchUser();
    };

    const updateAddress = async (address1) => {
        const token = localStorage.getItem(TOKEN_KEY);
        if (user?.defaultAddressId) {
            await shopifyCustomerAddressUpdate(token, user.defaultAddressId, { address1 });
        } else {
            await shopifyCustomerAddressCreate(token, { address1 });
        }
        await fetchUser();
    };

    return (
        <UserContext.Provider value={{ user, login, logout, register, fetchUser, updateCustomer, updateAddress }}>
            {children}
        </UserContext.Provider>
    );
};
